import React from 'react';
import '../styles/StaticPages.css';

const UsloviKoriscenja = () => {
  return (
    <div className="static-page">
      <h1>Uslovi Korišćenja</h1>
      <p className="update-date">Poslednje ažurirano: 25. Maj 2024.</p>

      <section>
        <h2>1. Prihvatanje Uslova</h2>
        <p>Korišćenjem našeg sajta prihvatate ove uslove i obavezujete se da ćete ih poštovati.</p>
      </section>

      <section>
        <h2>2. Registracija</h2>
        <ul>
          <li>Morate imati najmanje 18 godina za korišćenje usluga</li>
          <li>Obavezujete se da ćete dostaviti tačne podatke</li>
          <li>Odgovorni ste za sigurnost svog naloga</li>
        </ul>
      </section>

      <section>
        <h2>3. Intelektualna Svojina</h2>
        <p>Svi sadržaji na sajtu su vlasništvo MyZmaj.net i zabranjeno je njihovo kopiranje bez dozvole.</p>
      </section>

      <section>
        <h2>4. Ograničenje Odgovornosti</h2>
        <p>Ne snosimo odgovornost za:</p>
        <ul>
          <li>Gubitke nastale korišćenjem sajta</li>
          <li>Tehničke greške i prekide rada</li>
          <li>Sadržaj trećih strana</li>
        </ul>
      </section>

      <section>
        <h2>5. Promene Uslova</h2>
        <p>Zadržavamo pravo da menjamo ove uslove bilo kada. Obaveštaćemo korisnike putem emaila ili obaveštenja na sajtu.</p>
      </section>

      <section>
        <h2>6. Rešavanje Sporova</h2>
        <p>Svi sporovi rešavaju se u skladu sa zakonima Republike Srbije.</p>
      </section>
    </div>
  );
};

export default UsloviKoriscenja;